'use client';

import { Toaster } from '@/components/ui/toaster';
import './index.css';
import { AppRoutes } from './router';

function App() {
  return (
    <>
      <AppRoutes />
      <Toaster />
    </>
  );
}

export default App;
